import SubCollectionEntityService from '@/services/SubCollectionEntiyService'
import { PurchaseOrder, purchaseOrderConverter } from '@/models/purchaseOrder'
import BillService from './BillService'
import BudgetService from './BudgetService'

export default class PurchaseOrderService extends SubCollectionEntityService<PurchaseOrder> {
  constructor(parentDocument: string) {
    super({ parentDocument, subCollectionName: 'purchaseOrders', converter: purchaseOrderConverter })
  }

  async getByVendor(vendorId: string) {
    return await this.find_by('vendorId', '==', vendorId)
  }

  async deletePOWithBills (purchaseOrder: PurchaseOrder): Promise<boolean> {
    const billService = new BillService()
    const allPromises = []
    // Get all bills related to the purchase order
    const bills = await billService.getByPurchaseOrderId(purchaseOrder.purchaseOrderId)

    // Delete all bills related to the purchase order
    bills.forEach((bill) => {
      allPromises.push(billService.forceDelete(bill.id))
    })

    // Delete the purchase order
    const budgetService = new BudgetService()
    allPromises.push(budgetService.deletePurchaseOrder(purchaseOrder.budgetId, purchaseOrder.id))
    await Promise.all(allPromises)

    return true
  }
}
